export default __webpack_public_path__ + "static/media/icon_business.e7f44737.svg";